import { useFirebaseObject } from "./useFirebaseObject";

export const useBranch = (branchId: string) => {
  const [branch, updateBranch, isLoading] = useFirebaseObject(
    ["branches", branchId].join("/")
  );

  return { branch, updateBranch, isLoading };
};
